import * as React from 'react';

import {getIconDetails} from 'shells/connected-forms/helpers';
import {TwoLineMiniCard} from 'shells/two-line/two-line-mini-card';

import type {GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field} from 'nutshell-graphql-types';

import type {FormFieldSchema} from '../../../core/nutshell-fields/types';

import {getPreviewTitle, getPreviewSubtitle} from '../../connected-forms-list/helpers';

import styles from './activate-form-modal.module.css';

type Props = {
    connectedFields: Field[];
    entitiesString: string;
    formSchema: FormFieldSchema;
};

export function ConnectedFieldsSection(props: Props) {
    const fieldsToDisplay = props.connectedFields.slice(0, 7);
    const undisplayedCount = props.connectedFields.length - 7;

    return (
        <div className={styles['fields-section']}>
            <div className={styles.description}>
                <strong>
                    {props.connectedFields.length} field
                    {props.connectedFields.length === 1 ? '' : 's'}
                </strong>{' '}
                will begin adding data to {props.entitiesString} in Nutshell:
            </div>
            <div className={styles['connected-fields']}>
                {fieldsToDisplay.map((field) => {
                    const iconDetails = getIconDetails(field.entityName, field.isIgnored);

                    return (
                        <div key={field.id} className={styles.card}>
                            <TwoLineMiniCard
                                icon={iconDetails.icon}
                                iconColor={iconDetails.color}
                                iconSize={16}
                                topRow={getPreviewTitle(field, props.formSchema)}
                                bottomRow={getPreviewSubtitle(field, props.formSchema)}
                                width={325}
                            />
                        </div>
                    );
                })}
                {undisplayedCount > 0 ? (
                    <div className={styles['empty-card']}>+ {undisplayedCount} more fields</div>
                ) : undefined}
            </div>
        </div>
    );
}
